export default __webpack_public_path__ + "img/16.asset.e20ba5a0.jpeg";